<nav *ngIf="showBreadCrumbs" aria-label="breadcrumbs" class="bolt-space-bottom-2xl">
  <is-bread-crumbs
    class="breadCrumbs"
    [homeIconLink]="homeIconLink"
    [breadCrumbs]="breadCrumbs"
    [currentPage]="currentPage"
    position="top"
    [isClaims]="true">
  </is-bread-crumbs>
</nav>
<main>
  <div class="bolt-container">
    <div class="bolt-row bolt-space-bottom-2xl bolt-justify-content-between">
      <h1 class="bolt-col-12 bolt-heading-lg" [ngClass]="{'bolt-space-bottom-xl': isAuthenticated, 'bolt-space-bottom-2xl': !isAuthenticated}">Find a repair shop</h1>
      <div *ngIf="!isAuthenticated" class="bolt-col-12 bolt-space-left-xs bolt-space-bottom-xs">
        <div class="bolt-row">
          <bolt-icon name="person" title="person" color="vibrantBlue"></bolt-icon>
          <div class="bolt-row bolt-col-md-11">
            <div class="bolt-space-left-sm bolt-body-lg">Enter your vehicle information and an address or ZIP Code to search for shops in our On Your Side Auto Repair Network®.</div>
          </div>
        </div>
      </div>
      <div *ngIf="isAuthenticated" class="bolt-col-12 bolt-body-lg bolt-space-bottom-xl">
        <Strong>Discover the benefits of our <a class="bolt-link" href="https://www.nationwide.com/lc/resources/auto-insurance/articles/on-your-side-repair-network">On Your Side Auto Repair Network®</a></Strong>
      </div>
      <div class="bolt-space-bottom-xl bolt-body-lg"
        [ngClass]="{'bolt-col-12': isAuthenticated, 'bolt-col-md-11 bolt-space-left-2xl': !isAuthenticated}">For customers with a covered claim, the shops below offer a guarantee on parts and workmanship for as long as you own your vehicle<sup>1</sup>. You can pick any shop you'd like, though. Not just ours.</div>
      <div *ngIf="!isAuthenticated" class="bolt-col-12 bolt-space-bottom-xl">
        <div class="bolt-subheading-md">Step 1 of 2</div>
        <div class="bolt-subheading-lg">Tell us about your vehicle</div>
        <div class="bolt-row" [formGroup]="vehicleForm">
          <div class="bolt-col-sm bolt-space-bottom-md">
            <bolt-select label="Year" required placeholder="Select year" ngDefaultControl formControlName="year" (change)="onYearChange($event)" [attr.error]="formError.checkForError(vehicleForm, 'year')">
              @for (year of vehicleYearList; track year) {
                <option [value]="year.value" [selected]="year.value === selectedYear">{{ year.caption }}</option>
              }
            </bolt-select>
          </div>
          <div class="bolt-col-sm bolt-space-bottom-md">
            <bolt-select label="Make" required placeholder="Select make (e.g. FORD)" [disabled]="vehicleMakeList.length === 0" ngDefaultControl formControlName="make" (change)="onMakeChange($event)" [attr.error]="formError.checkForError(vehicleForm, 'make')">
              @for (make of vehicleMakeList; track make) {
                <option [value]="make.value" [selected]="make.value === selectedMake">{{ make.caption }}</option>
              }
            </bolt-select>
          </div>
          <div class="bolt-col-sm bolt-space-bottom-md">
            <bolt-select label="Model" required placeholder="Select model (e.g. F-150 CREW)" [disabled]="vehicleModelList.length === 0" ngDefaultControl formControlName="model" (change)="onModelChange($event)" [attr.error]="formError.checkForError(vehicleForm, 'model')">
              @for (model of vehicleModelList; track model) {
                <option [value]="model.value" [selected]="model.value === selectedModel">{{ model.caption }}</option>
              }
            </bolt-select>
          </div>
        </div>
        <div *ngIf="vehicleLookupMessage" class="bolt-row">
          <div class="bolt-col-12">
            <bolt-notification>
              {{ vehicleLookupMessage }}
            </bolt-notification>
          </div>
        </div>
      </div>
      <div class="bolt-col-12 bolt-space-bottom-xs" *ngIf="!isAuthenticated">
        <div class="bolt-subheading-md">Step 2 of 2</div>
        <div class="bolt-subheading-lg">Where should we look?</div>
      </div>
      <div class="bolt-col-12 bolt-space-bottom-xl">
        <is-search-bar [env]="env" [clientId]="clientId" [accessToken]="accessToken" [userTypeValue]="isAuthenticated"
          [selectedYear]="selectedYear" [selectedMake]="selectedMake" [selectedModel]="selectedModel"
          [vehicleForm]="!isAuthenticated ? vehicleForm : undefined"
          [claimId]="claimId"
          [externalClaimId]="externalClaimId" [vehicleIncidentId]="vehicleIncidentId"
          (shopDetails)="setShopData($event)" (loadAddress)="handleAddressLoaded($event)" (onError)="handleError($event)"
          [currentLocation]="currentLocation" [defaultSearchLocation]="defaultSearchLocation"></is-search-bar>
      </div>
      <div *ngIf="!isAuthenticated">
        <div class="bolt-col-12 bolt-space-left-xs bolt-space-bottom-2xl">
          <div class="bolt-row">
            <img
              src="assets/icons/lifeinsurance-outline.svg"
              alt=""
              id=""
              width="24" height="24">
            <div class="bolt-row bolt-col-md-11">
              <div class="bolt-space-left-sm bolt-body-lg">Have an active claim? <a class="bolt-link" href="https://login.nationwide.com/access/web/login.htm?uni_uuid=2a2619c4d4057eb595e3141 ">Log in to see your inspection options.</a></div>
            </div>
          </div>
        </div>
        <div class="bolt-col-12 bolt-heading-sm bolt-space-bottom-xl">
          With an <a class="bolt-link" href="https://www.nationwide.com/cp/cp-pdf/nationwides-oyn-auto-repair-network-infographic.pdf">On Your Side Auto Repair Network</a> shop, you get:
        </div>
        <div class="bolt-col-12 bolt-space-bottom-2xl">
          <div class="bolt-row bolt-align-items-start">
            <div class="bolt-col-md-3 bolt-col-12 bolt-align-items-center bolt-space-bottom-2xl">
              <div class="bolt-col-md-12 bolt-space-bottom-xs" style="text-align: center;">
                <img
                  src="assets/icons/legal-circle.svg"
                  alt=""
                  id=""
                  width="32" height="32">
              </div>
              <div class="bolt-col-auto bolt-col-md-12 bolt-body-lg bolt-space-bottom-xs" style="text-align: center;">
                A written guarantee on repairs as long as you own or lease the car.
              </div>
            </div>
            <div class="bolt-col-md-3 bolt-col-12 bolt-align-items-center bolt-space-bottom-2xl">
              <div class="bolt-col-md-12 bolt-space-bottom-xs" style="text-align: center;">
                <img
                  src="assets/icons/magnifyingglass-circle.svg"
                  alt=""
                  id=""
                  width="32" height="32">
              </div>
              <div class="bolt-col-auto bolt-col-md-12 bolt-body-lg bolt-space-bottom-xs" style="text-align: center;">
                Prescreened and qualified repair shops for the highest level of service.
              </div>
            </div>
            <div class="bolt-col-md-3 bolt-col-12 bolt-align-items-center bolt-space-bottom-2xl">
              <div class="bolt-col-md-12 bolt-body-lg bolt-space-bottom-xs" style="text-align: center;">
                <img
                  src="assets/icons/clock-circle.svg"
                  alt=""
                  id=""
                  width="32" height="32">
              </div>
              <div class="bolt-col-auto bolt-col-md-12 bolt-body-lg bolt-space-bottom-xs" style="text-align: center;">
                Streamlined claims handling, with repair shops handling the paperwork.
              </div>
            </div>
            <div class="bolt-col-md-3 bolt-col-12 bolt-align-items-center bolt-space-bottom-2xl">
              <div class="bolt-col-md-12 bolt-space-bottom-xs" style="text-align: center;">
                <img
                  src="assets/icons/chatx2-circle.svg"
                  alt=""
                  id=""
                  width="32" height="32">
              </div>
              <div class="bolt-col-auto bolt-col-md-12 bolt-body-lg bolt-space-bottom-xs" style="text-align: center;">
                Convenient communication; you can receive text or email updates.
              </div>
            </div>
          </div>
        </div>
        <div class="bolt-col-12 bolt-heading-lg bolt-space-bottom-xl">
          Are you a repair shop?
        </div>
        <div class="bolt-col-12 bolt-space-left-xs bolt-space-bottom-2xl">
          <div class="bolt-row">
            <img
              class="bolt-space-left-xs"
              src="assets/icons/towtruck-outline.svg"
              alt=""
              id=""
              width="24" height="24">
            <div class="bolt-row bolt-col-md-11">
              <div class="bolt-space-left-sm bolt-body-lg">Want to become part of our On Your Side Auto Repair Network? <a class="bolt-link" href="https://www.nationwide.com/lc/resources/auto-insurance/articles/on-your-side-repair-network">Find out how.</a></div>
            </div>
          </div>
        </div>
      </div>
      <div class="bolt-col-12 bolt-body-sm">
        <p>
          [1] Guarantee covers repair or replacement of any defective alternative parts identified on appraisal and
          used in repair for as long as you own or lease your repaired vehicle. Also, work performed at an On Your
          Side® Auto Repair Center includes a guarantee on the workmanship of the appraised and completed repairs for
          as long as you own or lease your vehicle.
        </p>
        <p>
          The auto repair shops found on this site are participants of the Nationwide Insurance On Your Side Auto
          Repair Network® program. None of the shops listed are owned by Nationwide Mutual Insurance Company nor by
          any of its affiliated or subsidiary companies.
        </p>
      </div>
    </div>
  </div>
</main>
